const data = {
    key: "b190a0605344cc4f3af08d0dd473dd25",
    base: "https://api.openweathermap.org/data/2.5/weather"
};

export default data;